import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { TRANSFORM_BEFORE, TRANSFORM_AFTER } from './salesData';
import { PHOTOS } from '../data/photos';
export function ProblemSolutionSection() {
  return <section id="problema-solucion" className="bg-white py-11 sm:py-14" data-id="element-215" data-mp="2gl22xlsu41o2">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-216" data-mp="2lj3uyw88nbbo">
        <div className="sm:grid sm:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] sm:items-center sm:gap-6" data-id="element-217" data-mp="2ljn3jmc00nd1">
          <img src={PHOTOS.process} alt="Base de glicerina derretida volcándose en un molde junto a jabones terminados" loading="lazy" decoding="async" className="h-36 w-full rounded-2xl object-cover sm:h-52" data-id="element-218" data-mp="396v6vypv9mcf" />

          <div className="mt-4 text-center sm:mt-0 sm:text-left" data-id="element-219" data-mp="348a6nzam72nz">
            <h2 className="mx-auto max-w-[22ch] font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:mx-0 sm:max-w-[24ch] sm:text-[2rem]" data-id="element-220" data-mp="1osuv9avb3zlt">
              No necesitás saber hacer jabones{' '}
              <span className="text-gold-deep" data-id="element-221" data-mp="yjlv08k3ui2s">para empezar.</span>
            </h2>

            <p className="mx-auto mt-2.5 max-w-[38ch] font-sans text-[0.86rem] leading-relaxed text-taupe sm:mx-0" data-id="element-222" data-mp="tl0ro09k3ia4">
              Con 200 fórmulas probadas, podés elegir qué crear y avanzar paso a paso.
            </p>
          </div>
        </div>

        <div className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-223" data-mp="13kjbmgpgv426">
          <div className="rounded-2xl bg-cream p-4 sm:p-5" data-id="element-224" data-mp="1hgmzztdnsi6q">
            <p className="font-display text-[0.62rem] font-bold uppercase tracking-editorial text-taupe" data-id="element-225" data-mp="1cjd53y7i3ebi">
              Probando a ciegas
            </p>
            <ul className="mt-3 space-y-2" data-id="element-226" data-mp="1r6y5vlgwl1g9">
              {TRANSFORM_BEFORE.map(item => <li key={item} className="flex gap-2 font-sans text-[0.83rem] leading-snug text-taupe" data-id="element-227" data-mp="1m9g7gp0ii4mi">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-taupe/50" aria-hidden strokeWidth={3} data-id="element-228" data-mp="208pb6p7j769l" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-gold bg-gold-soft p-4 sm:p-5" data-id="element-229" data-mp="sttz8awqvlio">
            <p className="font-display text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-230" data-mp="xvjanrnvq17a">
              Con las 200 fórmulas
            </p>
            <ul className="mt-3 space-y-2" data-id="element-231" data-mp="16nv3tlado2qy">
              {TRANSFORM_AFTER.map(item => <li key={item} className="flex gap-2 font-sans text-[0.83rem] font-semibold leading-snug text-charcoal" data-id="element-232" data-mp="1bmxv82xfqagg">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-233" data-mp="1gnc2vjv4jidy" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}